module.exports = __webpack_public_path__ + "static/guides.b60bb963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/guides.jpg
// module id = ./src/pages/guides.jpg
// module chunks = 13994203391546835000